<template>
  <div>
    <q-dialog v-model="show" maximized @input="(val) => $emit('input', val)">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{ $gettext('CREATE_NEW_CARRIER') }}</q-toolbar-title>
            <q-btn v-close-popup flat round dense icon="close" />
          </q-toolbar>
        </q-header>
        <q-page-container style="padding-top: 60px;" class="scroll">
          <carrier-page
            :params="params"
            :forms="forms"
            @action-button="actionButton"
            @show-message="showMessage"
          />
        </q-page-container>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import CarrierPage from '../../../modules/carrier/carrier/CarrierPage'
const { modal } = JtCrud

@Component({
  mixins: [modal],
  name: 'carrierSearchModal',
  components: { CarrierPage }
})
class CarrierSearchModal extends Vue {
  get _modal () {
    return CarrierPage
  }
}
export default CarrierSearchModal
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
.container-page-generator {
    height: calc(80vh);
}

.container-generator {
  .dynamic-form #scroll-area {
    height: calc(40vh - 12px) !important;
  }

 .dynamic-compositions{
    .dynamic-form #scroll-area {
    height: calc(50vh - 12px)!important;
  }
 }
}

@media only screen and (max-height: 880px) {
  .container-generator {
    .dynamic-form #scroll-area {
      height: calc(42vh - 12px) !important;
    }

  .addressPersonForms{
    .dynamic-form #scroll-area {
      height: calc(66vh - 12px) !important;
      }
    }
  }
}

@media only screen and (max-height: 800px) {
  .container-generator {
    .dynamic-form #scroll-area {
      height: calc(44vh - 12px) !important;
    }
  }
}
</style>
